module.exports = __webpack_public_path__ + "img/cashout.87fdefb5.svg";